import { FC } from 'react';
import * as React from 'react';
import 'twin.macro';
import 'styled-components/macro';

import { LevelBadge } from 'component-lib';
import { FluidContainer } from 'component-lib/atoms/container/FluidContainer';
import { ThemeableBackgroundContainer } from 'component-lib/atoms/container/ThemeableBackgroundContainer';
import { Level, TrackDetailsQuery } from 'types/graphql';

type TeamTheme = NonNullable<NonNullable<TrackDetailsQuery['team']>['theme']>;

export interface HeroProps {
  header: React.ReactNode;
  level?: Level;
  meta?: React.ReactNode;
  teaser: string;
  theme?: TeamTheme;
  title: string;
}

export const Hero: FC<HeroProps> = ({ header, level, meta, teaser, theme = {}, title, ...props }) => {
  return (
    <ThemeableBackgroundContainer
      tw="pb-2 pt-7"
      backgroundColor={theme.background_color}
      backgroundURL={theme.background_image}
      foregroundColor={theme.foreground_color}
      {...props}
    >
      <FluidContainer>
        <div tw="flex items-center mb-8">{header}</div>
        <div tw="grid grid-cols-3 gap-2">
          <div tw="col-span-3 lg:col-span-2 relative">
            <div tw="mb-5">
              <h1 tw="display-1">{title}</h1>
              <p tw="intro opacity-80">{teaser}</p>
            </div>
            {level && <LevelBadge tw="capitalize">{level}</LevelBadge>}
          </div>

          {meta && <div tw="row-start-2 col-span-3 lg:col-start-3 lg:col-end-3 relative">{meta}</div>}
        </div>
      </FluidContainer>
    </ThemeableBackgroundContainer>
  );
};
